{
	"title": "Access denied (403)",
	"description": "You do not have the necessary rights to access this page. Please ensure that you are logged in to an account with the appropriate permissions. Clearing your browser data might also resolve the issue. If you still need access, please get in contact with the system administrator.",
	"secondaryButtonTitle": "Logout"
}
